<template>
  <div class="list-con">
    <div class="list-title">审批中心</div>
    <ul class="tabs-list">
      <li :class="{'active':isActive}" @click="checkType">用户认证审核</li>
      <li :class="{'active':!isActive}" @click="checkType">企业认证审核</li>
    </ul>
    <!-- <transition name="fade" mode="out-in"> -->
    <keep-alive>
      <component :is="currentComponent" :key="currentComponent" />
    </keep-alive>
    <!-- </transition> -->

  </div>
</template>

<script>
import UserTable from './component/userTable.vue'
import CompanyTable from './component/companyTable.vue'
export default {
  components: {
    UserTable,
    CompanyTable
  },
  data() {
    return {
      isActive: true,
      currentComponent: 'UserTable'
    }
  },

  methods: {
    checkType() {
      this.isActive = !this.isActive
      this.currentComponent = this.isActive ? 'UserTable' : 'CompanyTable'
    }
  }
}
</script>


